import React, { createContext, useContext } from 'react';

export interface LureData {
  id: string;
  type: 'shabtai' | 'astrology' | 'numerology';
  title: string;
  value?: string;
  icon?: React.ReactNode;
  content: string;
  anchor?: {
    x: number;
    y: number;
    rect?: DOMRect;
  };
  innerSignNumber?: number | null;
  surroundingSignNumber?: number | null;
  turValue?: string;
  mapId?: string;
}

interface LureContextType {
  openLure: (lure: Omit<LureData, 'anchor'>, event?: React.MouseEvent) => void;
  closeLure: () => void;
}

const LureContext = createContext<LureContextType | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useLure = () => {
  const context = useContext(LureContext);
  if (!context) {
    throw new Error('useLure must be used within a LureProvider');
  }
  return context;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useOptionalLure = () => {
  return useContext(LureContext);
};

export { LureContext };
export type { LureContextType };
